import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemGroup.css'

/**
 * Item Group stacks a set of [Item](/components/item/) rows vertically and
 * exposes them to assistive technology as a list. Separate individual items
 * with [Item Separator](/components/item-separator/).
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for [Item](/components/item/) elements.
 */
@customElement('nord-item-group')
export default class ItemGroup extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'list')
    }
  }

  protected createRenderRoot() {
    return this
  }

  protected firstUpdated() {
    // Expose direct child items as list items so the list role has the
    // required children. Mirrors the `role="listitem"` the React demos add.
    for (const item of this.querySelectorAll(':scope > nord-item')) {
      if (!item.hasAttribute('role')) {
        item.setAttribute('role', 'listitem')
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-group': ItemGroup
  }
}
